// When a place's look changes (render/phasedLook.js draws it, for the street and the yards): a pure state machine,
// so node --test covers it.
// state = { shown, incoming, f }: `shown` is fully drawn, `incoming` fades in over it with alpha f.
import { STREET_LOOKS } from './streetLooks.mjs';

export const CROSSFADE_MS = 8000;

// The look the street starts from. The scene's preload() blocked on the look of the phase at that moment; if the
// phase changed while it downloaded, the wanted look isn't loaded, so start from one that is and let the fade bring
// the wanted one in (an unloaded start would leave the street empty under the sky).
export function startLook(look, ready, looks = STREET_LOOKS) {
  return [look, ...looks].find(ready) ?? look;
}

// A look is drawn from several pictures (the street's four tiles); it may start only when all of them are in.
export function lookReady(keys, has) {
  return keys.every(has);
}

// A wanted look that is not loaded yet never starts a fade (the old look stays, never a black street). A change
// of wanted look in the middle of a fade lets that fade finish first, so there is never more than one incoming.
export function lookTransition(state, { look, ready, dtMs }) {
  if (state.incoming) {
    const f = state.f + dtMs / CROSSFADE_MS;
    return f >= 1 ? { shown: state.incoming, incoming: null, f: 0 } : { ...state, f };
  }
  if (look === state.shown || !ready(look)) return state;
  const f = Math.min(dtMs / CROSSFADE_MS, 1);
  return f >= 1 ? { shown: look, incoming: null, f: 0 } : { shown: state.shown, incoming: look, f };
}

// Phones fetch no other look ahead of time (assetManifest otherPhases): the street asks for the next one in the
// second half of every 60-s phase (t = seconds into the 240-s cycle, farm/skyClock.mjs).
export const PREFETCH_AFTER_S = 30;
export function prefetchNextNow(t) {
  return ((t % 60) + 60) % 60 >= PREFETCH_AFTER_S;
}
